<div class="propero-home">
  <!-- Hero -->
  <section id="home" class="ph-hero ph-hero--compact">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>

    <div class="ph-container ph-hero__content--centered">
      <div class="ph-hero__badge">
        <span class="ph-hero__badge-dot" aria-hidden="true"></span>
        {{ 'FOOTER.MENU_COLLABORATION' | translate }}
      </div>

      <h1 class="ph-hero__title">Cum pot să devin colaborator Propero?</h1>
      <p class="ph-hero__subtitle">
        Alege modul de colaborare care ți se potrivește și începe să-ți gestionezi proprietățile mai eficient
      </p>
    </div>
  </section>

  <!-- Collaboration paths -->
  <section id="paths" class="ph-section">
    <div class="ph-container">
      <div class="ph-collab-grid">
        <!-- Proprietari -->
        <article id="owner" class="ph-collab-card ph-collab-card--owner">
          <header class="ph-collab-card__header">
            <div class="ph-collab-card__icon" aria-hidden="true"><i class="lni lni-user"></i></div>
            <h2 class="ph-collab-card__title">Proprietari</h2>
            <p class="ph-collab-card__lead">
              Gestionați-vă proprietățile în mod independent cu instrumentele noastre profesionale
            </p>
          </header>

          <div class="ph-collab-card__body">
            <h3 class="ph-collab-card__section-title">Cum funcționează?</h3>
            <ol class="ph-collab-steps">
              <li class="ph-collab-step">
                <span class="ph-collab-step__num">1</span>
                <div>
                  <strong>Creare cont</strong>
                  <p>Înregistrați-vă gratuit și configurați-vă profilul</p>
                </div>
              </li>
              <li class="ph-collab-step">
                <span class="ph-collab-step__num">2</span>
                <div>
                  <strong>Adăugare proprietăți</strong>
                  <p>Încărcați detaliile și fotografiile proprietăților</p>
                </div>
              </li>
              <li class="ph-collab-step">
                <span class="ph-collab-step__num">3</span>
                <div>
                  <strong>Gestionare chiriași</strong>
                  <p>Administrați contracte și comunicați cu chiriașii</p>
                </div>
              </li>
            </ol>

            <div class="ph-collab-lists">
              <div class="ph-collab-list-block">
                <h3>Beneficii</h3>
                <ul class="ph-collab-list">
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Control total asupra proprietăților</li>
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Instrumente profesionale de management</li>
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Suport tehnic dedicat</li>
                </ul>
              </div>
              <div class="ph-collab-list-block">
                <h3>Ce oferim</h3>
                <ul class="ph-collab-list">
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Dashboard personalizat</li>
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Rapoarte și analize</li>
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Notificări automate</li>
                </ul>
              </div>
            </div>

            <a [href]="assistantHref" target="_blank" rel="noopener noreferrer" class="ph-btn ph-btn--brand ph-btn--block ph-btn--lg">
              Începeți Acum
            </a>
          </div>
        </article>

        <!-- Propero Management -->
        <article class="ph-collab-card ph-collab-card--management">
          <header class="ph-collab-card__header">
            <div class="ph-collab-card__icon" aria-hidden="true"><i class="lni lni-consulting"></i></div>
            <h2 class="ph-collab-card__title">Propero Management</h2>
            <p class="ph-collab-card__lead">
              Lăsați gestionarea proprietăților în mâinile experților noștri
            </p>
          </header>

          <div class="ph-collab-card__body">
            <h3 class="ph-collab-card__section-title">Cum funcționează?</h3>
            <ol class="ph-collab-steps">
              <li class="ph-collab-step">
                <span class="ph-collab-step__num">1</span>
                <div>
                  <strong>Consultare inițială</strong>
                  <p>Evaluăm nevoile și stabilim strategia</p>
                </div>
              </li>
              <li class="ph-collab-step">
                <span class="ph-collab-step__num">2</span>
                <div>
                  <strong>Preluare proprietăți</strong>
                  <p>Ne ocupăm de toate aspectele administrative</p>
                </div>
              </li>
              <li class="ph-collab-step">
                <span class="ph-collab-step__num">3</span>
                <div>
                  <strong>Management activ</strong>
                  <p>Gestionăm totul în numele dumneavoastră</p>
                </div>
              </li>
            </ol>

            <div class="ph-collab-lists">
              <div class="ph-collab-list-block">
                <h3>Beneficii</h3>
                <ul class="ph-collab-list">
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Management profesionist</li>
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Economie de timp</li>
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Maximizarea profitului</li>
                </ul>
              </div>
              <div class="ph-collab-list-block">
                <h3>Ce oferim</h3>
                <ul class="ph-collab-list">
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Servicii complete de management</li>
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Verificare chiriași</li>
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Asistență 24/7</li>
                </ul>
              </div>
            </div>

            <a [href]="assistantHref" target="_blank" rel="noopener noreferrer" class="ph-btn ph-btn--brand ph-btn--block ph-btn--lg">
              Contactați-ne
            </a>
          </div>
        </article>

        <!-- Administratori -->
        <article id="manager" class="ph-collab-card ph-collab-card--manager">
          <header class="ph-collab-card__header">
            <div class="ph-collab-card__icon" aria-hidden="true"><i class="lni lni-home"></i></div>
            <h2 class="ph-collab-card__title">Administratori de imobile</h2>
            <p class="ph-collab-card__lead">
              Gestionați eficient portofoliul de proprietăți cu instrumente dedicate
            </p>
          </header>

          <div class="ph-collab-card__body">
            <h3 class="ph-collab-card__section-title">Cum funcționează?</h3>
            <ol class="ph-collab-steps">
              <li class="ph-collab-step">
                <span class="ph-collab-step__num">1</span>
                <div>
                  <strong>Configurare portofoliu</strong>
                  <p>Adăugați toate imobilele și unitățile administrate</p>
                </div>
              </li>
              <li class="ph-collab-step">
                <span class="ph-collab-step__num">2</span>
                <div>
                  <strong>Organizare activități</strong>
                  <p>Planificați și urmăriți toate activitățile de administrare</p>
                </div>
              </li>
              <li class="ph-collab-step">
                <span class="ph-collab-step__num">3</span>
                <div>
                  <strong>Management complet</strong>
                  <p>Gestionați cheltuieli, întreținere și comunicare</p>
                </div>
              </li>
            </ol>

            <div class="ph-collab-lists">
              <div class="ph-collab-list-block">
                <h3>Beneficii</h3>
                <ul class="ph-collab-list">
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Automatizare procese administrative</li>
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Gestionare eficientă a costurilor</li>
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Comunicare centralizată</li>
                </ul>
              </div>
              <div class="ph-collab-list-block">
                <h3>Ce oferim</h3>
                <ul class="ph-collab-list">
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Platformă specializată pentru administrare</li>
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Instrumente de raportare avansată</li>
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Asistență tehnică permanentă</li>
                </ul>
              </div>
            </div>

            <a href="#contact" class="ph-btn ph-btn--brand ph-btn--block ph-btn--lg">Contactați-ne</a>
          </div>
        </article>

        <!-- Agenții -->
        <article id="agent" class="ph-collab-card ph-collab-card--agent">
          <header class="ph-collab-card__header">
            <div class="ph-collab-card__icon" aria-hidden="true"><i class="lni lni-apartment"></i></div>
            <h2 class="ph-collab-card__title">Agenții imobiliare</h2>
            <p class="ph-collab-card__lead">Creșteți-vă afacerea cu soluția noastră white-label</p>
          </header>

          <div class="ph-collab-card__body">
            <h3 class="ph-collab-card__section-title">Cum funcționează?</h3>
            <ol class="ph-collab-steps">
              <li class="ph-collab-step">
                <span class="ph-collab-step__num">1</span>
                <div>
                  <strong>Personalizare brand</strong>
                  <p>Configurați platforma cu identitatea dvs. vizuală</p>
                </div>
              </li>
              <li class="ph-collab-step">
                <span class="ph-collab-step__num">2</span>
                <div>
                  <strong>Domeniu propriu</strong>
                  <p>Folosiți propriul domeniu sau subdomeniu</p>
                </div>
              </li>
              <li class="ph-collab-step">
                <span class="ph-collab-step__num">3</span>
                <div>
                  <strong>Lansare rapidă</strong>
                  <p>Începeți să folosiți platforma imediat</p>
                </div>
              </li>
            </ol>

            <div class="ph-collab-lists">
              <div class="ph-collab-list-block">
                <h3>Beneficii</h3>
                <ul class="ph-collab-list">
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Soluție white-label completă</li>
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Personalizare avansată</li>
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Integrare cu sistemele existente</li>
                </ul>
              </div>
              <div class="ph-collab-list-block">
                <h3>Ce oferim</h3>
                <ul class="ph-collab-list">
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Website personalizat</li>
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Sistem de management proprietăți</li>
                  <li><i class="lni lni-checkmark-circle" aria-hidden="true"></i> Suport tehnic dedicat</li>
                </ul>
              </div>
            </div>

            <a href="#contact" class="ph-btn ph-btn--brand ph-btn--block ph-btn--lg">Contactați-ne</a>
          </div>
        </article>
      </div>
    </div>
  </section>

  <!-- Partnership benefits -->
  <section id="partnership" class="ph-section ph-section--muted">
    <div class="ph-container ph-container--narrow">
      <div class="ph-section__header ph-section__header--center">
        <h2 class="ph-section__title">{{ 'FOOTER.COLLABORATION_TITLE' | translate }}</h2>
        <p class="ph-section__lead">{{ 'FOOTER.COLLABORATION_TEXT' | translate }}</p>
      </div>

      <h3 class="ph-collab-benefits__heading">{{ 'FOOTER.COLLABORATION_BENEFITS_TITLE' | translate }}</h3>

      <div class="ph-benefits-grid">
        <article class="ph-benefit-card">
          <div class="ph-benefit-card__icon" aria-hidden="true"><i class="lni lni-target"></i></div>
          <h4 class="ph-benefit-card__title">{{ 'FOOTER.COLLABORATION_BENEFIT_1_TITLE' | translate }}</h4>
          <p class="ph-benefit-card__text">{{ 'FOOTER.COLLABORATION_BENEFIT_1_DESC' | translate }}</p>
        </article>
        <article class="ph-benefit-card">
          <div class="ph-benefit-card__icon" aria-hidden="true"><i class="lni lni-network"></i></div>
          <h4 class="ph-benefit-card__title">{{ 'FOOTER.COLLABORATION_BENEFIT_2_TITLE' | translate }}</h4>
          <p class="ph-benefit-card__text">{{ 'FOOTER.COLLABORATION_BENEFIT_2_DESC' | translate }}</p>
        </article>
        <article class="ph-benefit-card">
          <div class="ph-benefit-card__icon" aria-hidden="true"><i class="lni lni-grow"></i></div>
          <h4 class="ph-benefit-card__title">{{ 'FOOTER.COLLABORATION_BENEFIT_3_TITLE' | translate }}</h4>
          <p class="ph-benefit-card__text">{{ 'FOOTER.COLLABORATION_BENEFIT_3_DESC' | translate }}</p>
        </article>
        <article class="ph-benefit-card">
          <div class="ph-benefit-card__icon" aria-hidden="true"><i class="lni lni-handshake"></i></div>
          <h4 class="ph-benefit-card__title">{{ 'FOOTER.COLLABORATION_BENEFIT_4_TITLE' | translate }}</h4>
          <p class="ph-benefit-card__text">{{ 'FOOTER.COLLABORATION_BENEFIT_4_DESC' | translate }}</p>
        </article>
      </div>

      <div class="ph-partner-cta">
        <div class="ph-partner-cta__content">
          <h3 class="ph-partner-cta__title">{{ 'FOOTER.COLLABORATION_CONTACT_TITLE' | translate }}</h3>
          <p class="ph-partner-cta__text">{{ 'FOOTER.COLLABORATION_CONTACT_TEXT' | translate }}</p>
          <a href="mailto:sales@propero.io" class="ph-btn ph-btn--brand ph-btn--lg">
            {{ 'FOOTER.COLLABORATION_CONTACT_BUTTON' | translate }}
          </a>
        </div>
        <div class="ph-partner-cta__visual">
          <img src="assets/images/collaboration/contact.jpg" alt="" loading="lazy" />
        </div>
      </div>
    </div>
  </section>

  <!-- Contact form -->
  <section id="contact" class="ph-section ph-section--contact">
    <div class="ph-container ph-contact__grid">
      <div class="ph-contact__info">
        <h2 class="ph-contact__title">{{ 'HOME.SECTION_CONTACTUS_HEADING' | translate }}</h2>
        <p class="ph-contact__lead">{{ 'HOME.SECTION_CONTACTUS_TEXT' | translate }}</p>

        <div class="ph-contact__channels">
          <div class="ph-contact__channel">
            <div class="ph-contact__channel-icon"><i class="lni lni-phone"></i></div>
            <div>
              <div class="ph-contact__channel-label">Telefon</div>
              <div class="ph-contact__channel-value">{{ 'COMPANY.CONTACT_MAIN_PHONE' | translate }}</div>
            </div>
          </div>
          <div class="ph-contact__channel">
            <div class="ph-contact__channel-icon"><i class="lni lni-envelope"></i></div>
            <div>
              <div class="ph-contact__channel-label">Email</div>
              <div class="ph-contact__channel-value">{{ 'COMPANY.CONTACT_MAIN_EMAIL' | translate }}</div>
            </div>
          </div>
        </div>
      </div>

      <form #contactForm="ngForm" (ngSubmit)="send()" class="ph-contact__form" novalidate>
        <div class="ph-field">
          <label for="collab-contact-name">{{ 'HOME.NAME' | translate }}</label>
          <input
            id="collab-contact-name"
            type="text"
            name="name"
            [(ngModel)]="contactItem.subject"
            required
            [placeholder]="'HOME.NAME' | translate" />
        </div>
        <div class="ph-field">
          <label for="collab-contact-email">{{ 'HOME.EMAIL' | translate }}</label>
          <input
            id="collab-contact-email"
            type="email"
            name="email"
            [(ngModel)]="contactItem.email"
            required
            email
            [placeholder]="'HOME.EMAIL' | translate" />
        </div>
        <div class="ph-field">
          <label for="collab-contact-message">{{ 'HOME.MESSAGE' | translate }}</label>
          <textarea
            id="collab-contact-message"
            name="message"
            rows="4"
            [(ngModel)]="contactItem.content"
            required
            [placeholder]="'HOME.MESSAGE' | translate"></textarea>
        </div>
        <button type="submit" class="ph-btn ph-btn--brand ph-btn--block ph-btn--lg" [disabled]="contactForm.invalid || isLoading">
          <span *ngIf="!isLoading">{{ 'HOME.SEND' | translate }}</span>
          <span *ngIf="isLoading">{{ 'HOME.SENDING' | translate }}</span>
        </button>
        <p *ngIf="contactSuccess" class="ph-contact__success">Mesaj trimis! Te contactăm în curând.</p>
      </form>
    </div>
  </section>
</div>
